import { Injectable } from '@angular/core';

import { FeatureFlag } from '@models/feature-flag.model';

import { BUDGETS_ROUTES_FEATURE_FLAGS } from '@shared/constants/feature-flags-guards/budgets-feature-flags.const';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { BasicRedirectToNextTabGuard } from '@shared/guards/basic-redirect-to-next-tab.guard';
import { Flags } from '@shared/services/launch-darkly.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentMilestonesGuard extends BasicRedirectToNextTabGuard {
  protected prefix = `/${ROUTING_PATH.BUDGET.INDEX}`;
  protected defaultNavigateUrl = `/${this.prefix}/${ROUTING_PATH.BUDGET.BUDGET.INDEX}`;
  protected featureFlag = FeatureFlag.PAYMENT_MILESTONES as keyof Flags;
  protected routerPathsAndFeatureFlags = BUDGETS_ROUTES_FEATURE_FLAGS;
}
